import {
  type ApiProblemDetails,
  getPayPointsPublicIDOwner,
  type PayPointOwnerDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { skipToken, useQuery } from "@tanstack/react-query";

const PAY_POINT_OWNER_QUERY_KEY = "PAY_POINT_OWNER";

export const payPointOwnerKeys = {
  all: [PAY_POINT_OWNER_QUERY_KEY],
  byId: (publicID?: string | null) => [...payPointOwnerKeys.all, publicID],
};

export const usePayPointOwnerQuery = (publicID?: string | null) =>
  useQuery<PayPointOwnerDto, ApiProblemDetails, PayPointOwnerDto>({
    queryKey: payPointOwnerKeys.byId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getPayPointsPublicIDOwner(publicID),
        )
      : skipToken,
    enabled: !!publicID,
    refetchOnWindowFocus: false,
  });
